import type { Event } from "./server/directus.server";

export const getEventLink = (event: Event) => {
    if(event.isRecurring) {
        return `/recurring/events/${event.translations[0].slug}`;
    }
    return `/years/${event.year}/events/${event.translations[0].slug}`;
}   